import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import Header from './Header';
import Email from './Email';
import Sns from './Sns';
import Footer from '../../components/Footer';
import { useAuthUserContext } from '../../providers';
import { useTitle } from '../../hooks/useTitle';

const LoginIndex = () => {
  const { user } = useAuthUserContext();
  const navigate = useNavigate();

  useTitle('Ton Bébé | ログイン');

  useEffect(() => {
    if (user) {
      navigate('/mypage');
    }
  }, [ user, navigate ]);

  return (
    <div>
      <Header />
      <main className="sub">
        <section className="login">
          <h1 className="sec_title">ログイン</h1>
          <div className="border_box">
            <Email />
            <Sns />
            <section>
              <p>新規登録をまだ行っていない方は<Link to="/register">こちら</Link>からご登録ください。</p>
            </section>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default LoginIndex;
